/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, ViewChild } from "@angular/core";
import { DraggableDirective } from "app/directives/draggable.directive";

/** Add variable $ for bootstrap support. */
declare var $: any;

@Component({
  selector: 'ef-simple-indefinite-progress-dialog',
  templateUrl: './simple-indefinite-progress-dialog.component.html'
})
export class SimpleIndefiniteProgressDialogComponent {

  /** Draggable Directive added to that the popup is draggable.  Referenced so that the position can be reset. */
  @ViewChild(DraggableDirective) draggableDirective: DraggableDirective;

  /** Title to give the Dialog */
  title: string = "Loading";

  /** Message to be displayed with the indefinite progress display */
  message: string = "Loading Information"

  /**
   * Displays the Indefinite Progress Dialog with the given Title / Message. 
   */
  public show(title: string, message: string): void {
    console.log(`Show - Title: '${title}', Message: '${message}'`);
    this.title = title;
    this.message = message;
    $("#indefiniteProgressDialog").show();
  }

  /**
   * Hides the Indefinite Progress Dialog.
   */
  public hide(): void {
    console.log(`Hide`);
    $("#indefiniteProgressDialog").hide();
  }

}
